import React from 'react';
import ChartSettingsComponent from "./ChartSettingsComponent";



function ChartHeaderComponent(props){

    function addHighlightingIfBarChart() {
        return props.viewType === 'barChart' ? 'questionaire__reports__container__title__actions--active' : '';
    }

    function addHighlightingIfPieChart(){
        return props.viewType === 'pieChart' ? 'questionaire__reports__container__title__actions--active': '';
    }

    function addHighlightingIfStackedChart(){
        return props.viewType === 'Stacked' ? 'questionaire__reports__container__title__actions--active': '';
    }
    function addHighlightingIfClusteredChart(){
        return props.viewType === 'Clustered' ? 'questionaire__reports__container__title__actions--active': '';
    }


    return(
    <React.Fragment>
        <div className="questionaire__reports__container__title">
            <span className="questionaire__reports__container__title__number">{props.questionData?.question.id.toUpperCase()}</span>
            <div className="questionaire__reports__container__title__text" style={props.titleStyle}>{props.questionData?.question.question}</div>
            <div className="questionaire__reports__container__title__actions">
                {
                    props.questionData?.question.type === 'singleChoice' && !props.isMobile &&
                    <a href="javascript:;" onClick={() => props.changeToBarChart()}
                       className={"questionaire__reports__container__title__actions__bar " + addHighlightingIfBarChart()}/>
                }
                {
                    props.questionData?.question.type === 'singleChoice' && !props.isMobile &&
                    <a href="javascript:;" onClick={() => props.changeToPieChart()}
                       className={"questionaire__reports__container__title__actions__diagram " + addHighlightingIfPieChart()}/>
                }
                {
                    props.questionData?.question.type === 'selects' && !props.isMobile && !props.isMultipleMatrix &&
                    <a href="javascript:;" onClick={() => props.changeToStackedChart()}
                       className={"questionaire__reports__container__title__actions__stacked " + addHighlightingIfStackedChart()}/>
                }
                {
                    props.questionData?.question.type === 'selects' && !props.isMobile &&
                    <a href="javascript:;" onClick={() => props.changeToClusteredChart()}
                       className={"questionaire__reports__container__title__actions__bar " + addHighlightingIfClusteredChart()}/>
                }
                {
                    (props.questionData?.question.type !== 'number' &&
                        props.questionData?.question.type !== 'multipleOpen' &&
                        props.questionData?.question.type !== 'text') &&
                    <a href="javascript:;"  onClick={props.toggleChartsSettings} className="questionaire__reports__container__title__actions__options"/>
                }

                {props.areDisplaySettingsActive &&
                <ChartSettingsComponent
                    viewType = {props.viewType}
                    questionType={props.questionData.question.type}
                    chartConfigurations={props.chartConfigurations}
                    setChartConfigurations={props.setChartConfigurations}
                    isMobile={props.isMobile}
                    refreshChart={props.refreshChart}
                />
                }
            </div>
        </div>
    </React.Fragment>
    )
}

export default ChartHeaderComponent;